module.exports = __webpack_public_path__ + "static/media/kahf_brand_banner.6e97aaf8.png";